module.exports = __webpack_public_path__ + "img/恐龙K歌机.c879ef4a.jpg";